import tripUpdatesSaga from './tripUpdatesSaga';

export default tripUpdatesSaga;
